<template>
  <div :class="$style.feature">
    <div
      v-for="(el, gameIndex) in data"
      :key="gameIndex"
      :class="$style.feature_wrap"
    >
      <the-game-gallery-intro :data="el" :class="$style.intro" />
      <ul :id="`js-game-feature-${gameIndex}`">
        <li v-for="(img, imgIndex) in el.feature_img" :key="imgIndex">
          <img v-lazy="lazyImg(img)" :alt="el.title" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TheGameGalleryIntro from './TheGameGalleryIntro'

export default {
  components: { TheGameGalleryIntro },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    lazyImg(src) {
      return {
        src,
        loading: require('./images/loading.jpg'),
      }
    },
  },
}
</script>

<style lang="less" module>
.feature {
  margin-left: 6.96rem;

  &_wrap:last-child {
    li:last-child {
      padding-bottom: 0;
    }
  }

  li {
    padding-bottom: 0.34rem;

    img {
      .size(8.84rem, 5rem);
    }
  }
}

.intro {
  display: none;
}

@media screen and (max-width: @mini-width) {
  .feature {
    margin-left: 0.5rem;
    margin-right: 0.5rem;

    &_wrap:not(:first-child) {
      margin-top: 2em;
      padding-top: 2em;
      border-top: 1px solid #eee;
    }

    ul {
      display: flex;
      justify-content: space-between;
    }

    li {
      padding-bottom: 0;
    }
  }

  .intro {
    display: block;
    margin-bottom: 1em;
    text-align: right;

    img {
      display: none;
    }

    h2 {
      margin-top: 0;
      text-align: left;

      em {
        display: block;
        font-weight: 700;
      }

      span {
        display: none;
      }
    }

    p {
      margin-bottom: 1em;
      font-size: 12px;
      text-align: left;
    }

    a {
      .size(auto);
      display: inline-block;
      font-size: 12px;

      i {
        display: none;
      }

      span:nth-child(1) {
        .size(auto);
        position: static;
        display: inline-block;
        padding: 0.5em 1em;
      }

      span:nth-child(2) {
        display: none;
      }
    }
  }
}
</style>
